import React from 'react'

import ConfirmLine from '../items/ConfirmLine'
import { FormTitleProps } from '../items/FormTitle'
import BaseGroup from './BaseGroup'

/**
 * 編集画面で利用する確認グループ(地図選択後など)
 */
const ConfirmGroup: React.FC<ConfirmGroupProps> = (props) => {
  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      <ConfirmLine
        titleLabel={props.titleLabel}
        content={props.content}
        changeLinkTo={props.changeLinkTo}
      />
    </BaseGroup>
  )
}

export type ConfirmGroupProps = FormTitleProps & {
  titleLabel: string
  content: React.ReactNode
  changeLinkTo: string
}

export default React.memo<ConfirmGroupProps>(ConfirmGroup)
